import { useEffect, useState } from 'react';
import { useToken } from './TokenContext';
import { Navigate, useLocation } from 'react-router-dom';

const ProtectedRoute = ({ element, type }) => {
    const { isAuthenticated, checkToken, setIsAuthenticated } = useToken();
    const [fadeOut, setFadeOut] = useState(false);
    const storedUserType = localStorage.getItem('user_type'); 
    
    useEffect(() => {
        if (isAuthenticated === null) {
            checkToken();
        }
    }, [isAuthenticated, checkToken]);

    useEffect(() => {
        const timer = setTimeout(() => setFadeOut(true), 600);
        return () => clearTimeout(timer);
    }, []);


    if (isAuthenticated === null) {
        return (
            <div className={`fixed left-0 top-0 z-[999999] flex h-screen w-screen items-center justify-center bg-white transition-opacity duration-300 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}>
                <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
            </div>
        );
    }

    if (isAuthenticated) {
        if (type == 'administrador' && (storedUserType == 'participante' || storedUserType == 'supervisor'  )) {
            return <Navigate to="/" replace />;
        }

        if ((type == 'participante' || type === 'supervisor') && storedUserType == 'administrador') {
            return <Navigate to="/manager" replace />;
        }

        return element;
    }
    
    return  <Navigate to={`${type == 'administrador' ? '/manager/login' : '/participantes/login/'}`} replace />;
};

export default ProtectedRoute;